import { render } from "./HeaderBand.vue?vue&type=template&id=35271bee&scoped=true&ts=true"
import script from "./HeaderBand.vue?vue&type=script&lang=ts"
export * from "./HeaderBand.vue?vue&type=script&lang=ts"

import "./HeaderBand.vue?vue&type=style&index=0&id=35271bee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35271bee"]])

export default __exports__